/**
 * When a self-funding account has enough detail to be projected. One rule for the account list, the
 * account card and the assessment's readiness check: a balance and a tax rate, plus a growth rate
 * for investment accounts (income streams such as pensions have no growth rate to enter).
 */
import { isIncomeStreamAccountType } from '@shared';

export function isSelfFundingAccountComplete(source: SelfFundingSource | undefined): boolean {
  if (!source) return false;
  if (isIncomeStreamAccountType(source.accountType)) {
    return source.existingAssetsValue !== null && source.gainsTaxRate !== null;
  }
  return (
    source.existingAssetsValue !== null &&
    source.annualRateOfReturn !== null &&
    source.gainsTaxRate !== null
  );
}

/** Self-funding accounts (not deactivated, not the existing-policy placeholder) that are complete. */
export function countCompleteSelfFundingAccounts(
  selfFunding: Record<string, SelfFundingSource> | undefined,
): number {
  return Object.values(selfFunding ?? {}).filter(
    source =>
      source.accountType !== 'existingLtcPolicy' &&
      !source.isDeactivated &&
      isSelfFundingAccountComplete(source),
  ).length;
}
